export default {
  sui: {
    loading: {
      text: '加載中'
    },
    form: {
      more: '更多',
      zhankai: '展開',
      shouqi: '收起',
      query: '查詢',
      reset: '重置',
      add: '添加',
      update: '更新',
      delete: '刪除',
      required: '為必填項',
      export: {
        export: '導出',
        selectFormat: '選擇格式',
        selectedRow: '已選擇 {key} 行',
        selectedTotal: '共 {key} 行，導出',
        line: '行'
      },
      please: {
        input: '請輸入',
        select: '請選擇'
      },
      time: {
        start: '開始時間',
        end: '結束時間',
        to: '至'
      },
      date: {
        start: '開始日期',
        end: '結束日期'
      },
      upload: {
        triggerText: '上傳'
      },
      expand: '展開',
      multiple: '多選',
      cols_hide: '表頭設置'
    },
    table: {
      handle: '操作',
      sum: '合計',
      index: '序號',
      zanwushuju: '暫無數據',
      queding: '確定',
      quxiao: '取消',
      lie: '列',
      yiyincang: '已隱藏',
      gong: '共'
    },
    tableEdit: {
      tip1: '數據仍在編輯狀態，無法保存！',
      tip2: '確定要刪除該數據嗎？',
      baocun: '保存',
      chongzhi: '重置',
      xinzeng: '新增',
      guanbituozhuai: '關閉拖拽',
      kaiqituozhuai: '開啟拖拽',
      caozuo: '操作',
      queren: '確定',
      bianji: '編輯',
      shanchu: '刪除',
      tishi: '提示'
    },
    list: {
      yi_xuan_ze: '已選擇',
      tiao: '條',
      gong: '共',
      mei_you_geng_duo: '沒有更多',
      zan_wu_shu_ju: '暫無選中數據'
    },
    bond: {
      zheng_quan_dai_ma: '證券代碼',
      zheng_quan_ming_cheng: '證券名稱',
      zan_wu_shu_ju: '暫無數據',
      qu_xiao_qing_qiu: '請求已取消'
    },
    dialog: {
      ok: '確定',
      cancel: '取消'
    },
    page: {
      add: {
        success: '添加 [{key}] 成功'
      },
      delete: {
        title: '{key}-刪除',
        confirm: '確認刪除 [{key}] 嗎？',
        success: '刪除 [{key}] 成功'
      },
      update: {
        success: '更新 [{key}] 成功',
        noChange: '數據未變更，無需保存'
      }
    },
    tablePage: {
      export: {
        tip1: '請輸入正確的行數',
        tip2: '導出類型',
        tip3: '選擇',
        tip4: '導出為',
        tip5: '請選擇導出文件類型',
        lie: '列',
        hang: '行',
        shi: '是',
        fou: '否',
        daochu: '導出',
        wancheng: '完成',
        quxiao: '取消',
        gong: '共',
        type1: '順序導出',
        type2: '手動勾選導出',
        daochu_geshi: '導出文件類型'
      }
    },
    editlist: {
      caozuo: '操作',
      shanchu: '刪除',
      xinzeng: '新增'
    },
    upload: {
      tip1: '按刪除鍵刪除'
    },
    uploadPro: {
      tip1: 'Websocket 連接斷開，正在嘗試重新連接',
      tip2: '連接已斷開'
    },
    select: {
      jiazaizhong: '加載中',
      wupipeishuju: '無匹配數據',
      wushuju: '暫無數據',
      quanxuan: '全選',
      fanxuan: '反選'
    },
    transfer: {
      tip1: '搜索',
      liebiao1: '列表一',
      liebiao2: '列表二'
    },
    treeGrid: {
      caozuolan: '操作欄'
    },
    empty: {
      zanwuneirong: '暫無內容'
    },
    valid: {
      char: '字符',
      len1: '請輸入 {p1} 個',
      len2: '請輸入 {p1} 到 {p2} 個',
      num: '數字字符',
      pInt: '正整數',
      npInt: '非正整數',
      nInt: '負整數',
      nNInt: '非負整數',
      int: '整數',
      pFNum: '正浮點數',
      nFNum: '負浮點數',
      num_: '數字(-,_)字符',
      en: '英文字符',
      en_: '英文(-,_)字符',
      ch: '中文字符',
      ch_: '中文(-,_)字符',
      nch: '非中文字符',
      numEn: '數字或英文字符',
      numEn_: '數字或英文(-,_)字符',
      chEnNum: '數字或英文或中文字符',
      chEnNum_: '數字或英文或中文(-,_)字符',
      phone: '電話號碼',
      email: '電子郵箱',
      idcard: '身份證號',
      url: '網址',
      reg: '請輸入正確的',
      version: '版本號',
      uri: 'URI',
      datasource: '數據源',
      intRegion: '整數範圍 {p1} 到 {p2}',
      floatRegion: '浮點數範圍 {p1} 到 {p2}'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: '絕對時間範圍',
      xiang_dui_shi_jian_fan_wei: '相對時間範圍',
      kai_shi_shi_jian: '開始時間',
      jie_su_shi_jian: '結束時間',
      zui_jin_wu_fen_zhong: '最近5分鐘',
      zui_jin_shi_wu_fen_zhong: '最近15分鐘',
      zui_jin_san_shi_fen_zhong: '最近30分鐘',
      zui_jin_yi_xiao_shi: '最近1小時',
      zui_jin_san_xiao_shi: '最近3小時',
      zui_jin_liu_xiao_shi: '最近6小時',
      zui_jin_shi_er_xiao_shi: '最近12小時',
      zui_jin_er_shi_si_xiao_shi: '最近24小時',
      zui_jin_liang_tian: '最近2天',
      zui_jin_qi_tian: '最近7天',
      zui_jin_san_shi_tian: '最近30天'
    },
    bookmark: {
      biao_ti: '書籤',
      xin_zeng_shu_qian: '新增書籤',
      ming_cheng: '名稱',
      fu_gai: '覆蓋',
      chong_ming_ming: '重命名',
      shan_chu: '刪除',
      ming_cheng_xiu_gai_cheng_gong: '名稱修改成功',
      xin_zeng: '新增',
      shan_chu_ti_shi: '確認刪除 [{name}] 嗎？',
      shan_chu_cheng_gong: '刪除成功',
      xin_zeng_cheng_gong: '新增書籤成功！',
      tian_jia_ji_lu: '添加到歷史記錄',
      gong: '共',
      tiao: '條',
      bao_cun: '保存',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: '請確認正在添加的記錄'
    },
    messageBox: {
      qing_shuru_yanzhengma: '請輸入驗證碼',
      yanzhengma_bu_zhengque: '驗證碼不正確'
    },
    jsonEditor: {
      fuzhi: '複製'
    },
    cron: {
      second: '秒',
      minute: '分鐘',
      hour: '小時',
      day: '天',
      month: '月',
      week: '週',
      year: '年',
      cron_biaodashi_ziduan: 'Cron 表達式字段',
      hanhua_fanyi: '中文翻譯',
      chongzhi: '重置',
      single: '每',
      mei_nian: '每年',
      mei_yue: '每月',
      mei_ri: '每日',
      mei_tian: '每天',
      mei_shi: '每小時',
      xiaoshi: '小時',
      mei_fenzhong: '每分鐘',
      mei_miao: '每秒',
      mei_zhou: '每週',
      cong: '從',
      yue_qi_mei_ge: '每月第',
      ri_qi_mei_ge: '每天第',
      shi_qi_mei_ge: '每小時第',
      fenzhong_qi_mei_ge: '每分鐘第',
      miao_qi_mei_ge: '每秒第',
      zuihou_yitian: '最後一天',
      zhi: '至',
      cong_zhou: '從週',
      zhi_zhou: '至週',
      qi_meige: '每',
      tian_zhixingyici: '每天執行一次',
      xiaoshi_zhixingyici: '每小時執行一次',
      yue_zhixingyici: '每月執行一次',
      zhixingyici: '執行一次',
      ben_yue_di: '本月第',
      ben_yue: '本月',
      xinqi: '週',
      benyue_zuihou_yige_xingqi: '本月最後一個週',
      buzhiding: '不指定',
      zhouqi_cong: '週期從',
      xunhuan_cong: '循環從',
      tip1: '每天',
      tip2: '最近工作日',
      tip3: '開始，每小時',
      tip4: '開始，每月',
      tip5: '週',
      benyue_zuihou_yitian: '本月最後一天',
      zhiding: '指定',
      kaishi: '開始',
      kaishi_mei: '開始每',
      benyue: '本月',
      mei: '每',
      zhixing: '執行',
      zhouqi: '週期',
      di: '第',
      mess1: '日期和週不能同時為"不指定"',
      mess2: '日期和週必須有一個為"不指定"',
      zhouri: '週日',
      zhouyi: '週一',
      zhouer: '週二',
      zhousan: '週三',
      zhousi: '週四',
      zhouwu: '週五',
      zhouliu: '週六'
    },
    treeGraph: {
      fangda: '放大',
      suoxiao: '縮小',
      shuaxin: '刷新'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/zh-TW.js